'use client';

import { ButtonLink } from '@packages/shared/src/ui/Button/Button';
import clsx from 'clsx';
import type { JSX } from 'react';

export type SuccessPageProps = {
  /** The Icon at the top. If unset, the green Tick is used */
  icon?: JSX.Element;
  /** Main Headline */
  headline: string;
  /** Text under the headline */
  description: string;
  /** Button that links to Home Page */
  button?: {
    /** Button text */
    text: string;
    /** If true, the button is colorful and can be used as a CTA */
    primary?: boolean;
  };
  /** less important Text at the bottom */
  subtext?: string;
};

/**
 * Renders a Success Icon with headline and description to notify about
 * a successfully submitted form.
 */
export const SuccessPage = ({ icon, headline, description, button, subtext }: SuccessPageProps) => (
  <div className="mx-auto my-0 flex max-w-lg flex-col p-4 pt-5 text-center">
    <div className="mb-1">
      {icon || <span className="icon-emp-checkmark text-color-success size-[5rem]" />}
    </div>
    <p className="text-size-h3 mb-2.5">{headline}</p>
    <span>{description}</span>
    {button && (
      <ButtonLink
        className={clsx(
          button.primary ? 'bg-color-primary text-color-primary-contrasttext mt-4' : 'mt-6.5',
        )}
        href="/"
      >
        {button.text}
      </ButtonLink>
    )}
    {subtext && <p className="text-size-body2 text-color-text-darktransparent pt-2.5">{subtext}</p>}
  </div>
);
